import { notifyError } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const getSingleOfferForSeller = (id) => async (dispatch) => {
  dispatch({ type: "SHOW_SINGLE_BRAND_LOADING" });
  try {
    const { data } = await auction.get(
      `/auction/read/seller/single-offer/${id}`
    );
    dispatch({ type: "GET_SINGLE_BRAND", payload: data });
  } catch (error) {
    notifyError(error.response ? error.response?.data : error.message, error.response?.status);
    dispatch({ type: "HIDE_SINGLE_BRAND_LOADDED" });
  }
};

export const getSingleOfferForBuyer = (id) => async (dispatch) => {
  dispatch({ type: "SHOW_SINGLE_BRAND_LOADING" });
  try {
    const { data } = await auction.get(
      `/auction/read/buyer/single-offer/${id}`
    );
    dispatch({ type: "GET_SINGLE_OFFERS", payload: data });
  } catch (error) {
    notifyError(error.response ? error.response?.data : error.message, error.response?.status);
    dispatch({ type: "HIDE_SINGLE_BRAND_LOADDED" });
  }
};

export const getSingleCompletedOfferForSeller = (auctionId, offerId) => async (dispatch) => {
  dispatch({ type: "COMPLETED_OFFER_LOADING" });
  try {
    const { data } = await auction.get(
      `/auction/read/completed/single-offer/${auctionId}/${offerId}`
    );
    dispatch({ type: "COMPLETED_OFFER_SUCCESS", payload: data });
  } catch (error) {
    notifyError(error.response ? error.response?.data : error.message, error.response?.status);
    dispatch({ type: "COMPLETED_OFFER_FAILED" });
  }
};

export const getLotPriceApproval = (auctionId, offerId, bidderId, setIsAcceptModalOpen) => async (dispatch) => {
  dispatch({ type: "ACCEPT_BIDDER_PRICE_LOADING" });
  try {
    const { data } = await auction.put(
      `/auction/update/accept-offer/${auctionId}/${offerId}/${bidderId}`
    );
    setIsAcceptModalOpen(false);
    dispatch({ type: "ACCEPT_BIDDER_PRICE_SUCCESS", payload: data });
  } catch (error) {
    notifyError(error.response ? error.response?.data : error.message, error.response?.status);
    dispatch({ type: "ACCEPT_BIDDER_PRICE_FAILED" });
  }
};

export const lotPriceRejection = (auctionId, offerId, setIsRejectModalOpen) => async (dispatch) => {
  dispatch({ type: "REJECT_BIDDER_PRICE_LOADING" });
  try {
    const { data } = await auction.put(
      `/auction/update/reject-offer/${auctionId}/${offerId}`
    );
    setIsRejectModalOpen(false);
    dispatch({ type: "REJECT_BIDDER_PRICE_SUCCESS", payload: data });
  } catch (error) {
    notifyError(error.response ? error.response?.data : error.message, error.response?.status);
    dispatch({ type: "REJECT_BIDDER_PRICE_FAILED" });
  }
};

